import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import {
  UntypedFormBuilder,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { FormErrors } from '../../../shared/api/response.error';
import { PasswordLoginMethod } from '../../../shared/api/types';
import { RecaptchaService } from '../../../shared/recaptcha.service';
import { SavedUsernameService } from '../../../shared/saved-username.service';
import {
  SpenFormField,
  SpenInput,
  SpenLink,
  SpenFormError,
  SpenCheckbox,
  SpenButton,
} from '@classi/spen';

import { RouterLink } from '@angular/router';

export type PasswordLoginChallengeParams = {
  password: string;
  saveId: boolean;
  'g-recaptcha-response': string | undefined;
  manabi?: boolean;
};

@Component({
  selector: 'app-password-login-challenge',
  templateUrl: './password-login-challenge.component.html',
  styleUrls: ['./password-login-challenge.component.scss'],
  imports: [
    ReactiveFormsModule,
    SpenFormField,
    SpenInput,
    SpenLink,
    SpenFormError,
    SpenCheckbox,
    RouterLink,
    SpenButton,
  ],
})
export class PasswordLoginChallengeComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  private readonly fb = inject(UntypedFormBuilder);
  private readonly savedIdService = inject(SavedUsernameService);
  private readonly recaptchaService = inject(RecaptchaService);

  @Input()
  password = '';
  @Input()
  loginMethod!: PasswordLoginMethod;
  @Input()
  formErrors: FormErrors | null = null;
  @Input()
  submitInProgress = false;

  @Output()
  challenge = new EventEmitter<PasswordLoginChallengeParams>();

  @ViewChild('grecaptchaContainer')
  grecaptchaContainer: ElementRef<HTMLElement> | null = null;
  @ViewChild('passwordInput', { read: ElementRef, static: false })
  passwordInput: ElementRef<HTMLElement> | null = null;

  readonly form = this.fb.group({
    password: this.fb.control('', {
      validators: [Validators.required],
    }),
    saveId: this.fb.control(this.savedIdService.getId() !== null),
  });

  isPasswordVisible = false;

  ngOnInit(): void {
    this.form.controls.password.setValue(this.password);
  }

  ngAfterViewInit(): void {
    // ページを開いた時にパスワード入力欄にフォーカス
    if (this.passwordInput) {
      this.passwordInput.nativeElement.focus();
    }
    if (this.grecaptchaContainer) {
      const recaptchaControl = this.fb.control(null, {
        validators: [Validators.required],
      });
      this.form.addControl('g-recaptcha-response', recaptchaControl);

      this.recaptchaService
        .render(this.grecaptchaContainer.nativeElement)
        .subscribe(
          (token) => {
            recaptchaControl.setValue(token);
          },
          (error) => {
            recaptchaControl.setValue(null);
          }
        );
    }
  }

  ngOnDestroy(): void {
    this.recaptchaService.destroyWidget();
  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  onSubmit() {
    this.challenge.emit(this.form.value);
  }
}
